module.exports = __webpack_public_path__ + "img/icon_table_price_bidv.23d15990.svg";